import { Rules } from '@/types/Rules';

const rules: Rules = {
  intro: {
    title: 'Welcome to the world of Samurai',
    body: `<p>In ancient Japan, you play for the emperor's throne. Only building palaces will ensure your power. Move by move you need to collect the necessary materials.</p>
    <p>
    You battle your opponents with brave Samurai warriors to plunder their material. A successful attack not only slows down the enemy's palace construction, but also accelerates your own.
    </p>
    
    <p>Only if you combine your resources wisely, act strategically and fight bravely, you will build your third palace and go into history as the great emperor.</p>
    
    <h3>ATTACK, HAI!!!</h3>

    <div class="col-12 col-sm-6 offset-sm-3 my-12">
      <a class="btn-icon"
          href="https://playtricto.com/downloads/tricto_samurai_rules_EN.pdf"
          title="Download the rules as PDF" target="_blank"
          >
          <span class="btn-icon__icon btn-icon__icon--pdf" ></span> <span class="btn-icon__text">Download Rules</span>
      </a>
    </div>

    <div class="video-container" style="margin-top: 2rem">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/MOJ2IWsCKos" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  
    `,
  },
  areas: [
    // Preparation
    {
      title: 'Before the action begins',
      classes: 'bg-beige',
      chapters: [
        {
          title: 'Goal of the game',
          body: ` 
          <div class="row">
            <div class="col-12 col-sm-6">

              <h3>2, 3 or 4 Players:</h3>
              <p>
              Whoever builds <strong>3 palaces</strong> first, will win the game.
              </p>

              <div class="col-12 col-sm-8">
                <img src="/images/tricto-rules-game-end-a.jpg" class="image-responsive" />
              </div>

              <hr />

              <h3>5 or 6 Players:</h3>
              <p>
                <strong>2 palaces</strong> are enough to win.
              </p>

              <div class="col-12 col-sm-8">
                <img src="/images/tricto-rules-game-end-b.jpg" class="image-responsive" />
              </div>
              
              
              </div>

            <div class="col-12 col-sm-6">
            <p>
              To build palaces, you collect materials out of the 3&nbsp;resources: rice,&nbsp;ore&nbsp;and&nbsp;bamboo.
              </p>
              <p>
              With your Samurai you are able to plunder 1&nbsp;material from enemies and defend yours.
              </p>
              <p>
              But you also need resources for the training of Samurai&nbsp;…
              </p>

              <img src="/images/tricto-rules-game-fill-a.jpg" class="image-responsive" />

            </div>
          </div>
          
          `,
        },
        {
          title: 'The 109 cards',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Palaces</h4>
              <p>Whoever builds their 3rd (or 2nd) palac first, wins the game.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-objectives.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Resources</h4>
              <p>In order to build a palace, you have to collect one resource of each type as material. You also need resources for Samurai and Shoguns.</p>
              <p>There is: rice, ore and bamboo.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-resources.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Samurai</h4>
              <p>You need them to fight for opponent's material and to defend yours.</p>
              <p>There are: Lance-, Sword- and Bow-Samurai.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-fighters.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Shoguns</h4>
              <p>A Shogun brings advantages: you can train more Samurai and pick up more cards.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-booster.jpg" class="image-responsive mt-n3" />
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12 col-sm-6">
              <h4>Ninja</h4>
              <p>He appears unexpectedly and helps the weakest player.</p>
            </div>
          
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-cards-special.jpg" class="image-responsive mt-n3" />
            </div>
          </div>
          `,
        },
        {
          title: 'Preparation',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">1.</span> Palaces and Ninja</h4>
              <p>
              Collect all 12 palaces and the Ninja out of the game.
              </p>
              
              <hr />
              
              <h4><span class="typo-highlight">2.</span> Palace Construction</h4>
              <p>
              <strong>2-4 players:</strong> Each player gets <strong>3</strong> palaces ...
              <br>
              <strong>5-6 players:</strong> Each player gets <strong>2</strong> palaces ...
              </p>
              <p>
                ... and puts them face down stacked in front of her/him as "palace construction".
              </p>
        
              <p>
              The remaining palaces are no longer needed. Put them aside.
              </p>

            </div>
            
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-prepare-a-EN.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Sort out all palaces and the Ninja
              </p>
              <img src="/images/tricto-rules-prepare-b-EN.jpg" class="image-responsive mt-6" />
              <p class="typo-note">
                Put your "palace construction" in front of you
              </p>
            </div>
            
            <div class="col-12 col-sm-6 my-n3">
              <hr />
            </div>

            <div class="col-12 col-sm-6 my-n3">
            </div>
            
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">3.</span> Prepare draw pile</h4>
                <p>
                The other cards get shuffled well and are placed in the center as the "draw pile".
                </p>
                
                <hr />

              <h4><span class="typo-highlight">4.</span> 3 cards on the market</h4>
              <p>
              3 cards from the draw pile are placed face up in the center as a "market".
              </p>
              
              <hr />

                <h4><span class="typo-highlight">5.</span> Discard pile</h4>
                <p>
                From discarded cards a "discard pile" will be formed. When the draw pile is empty, the discard pile is shuffled and used again as a draw pile.
                </p>
              </div>
            
              <div class="col-12 col-sm-6">
                <img src="/images/tricto-rules-prepare-c-EN.jpg" class="image-responsive mt-n3" />
                <p class="typo-note">
                Put the market and draw pile in the center
                </p>
              </div>
              
              <div class="col-12 col-sm-6 my-n3">
                <hr />
              </div>

              <div class="col-12 col-sm-6 my-n3">
              
              </div>


            <div class="col-12 col-sm-6">


              
              <h4><span class="typo-highlight">6.</span> 6 cards in hand</h4>
              <p>
              Each player receives 6 cards face down from the draw pile into their hand.
              </p>
              
              <hr />

              <h4><span class="typo-highlight">7.</span> Ninja</h4>
              <p>
              Now shuffle the Ninja into the draw pile.
              </p>
              
              <hr />

              <h4><span class="typo-highlight">8.</span> Who begins?</h4>
              <p>
              This is decided by the owner of the game. Roll a dice or pull a match? Whatever. Be creative.
              </p>
              
              </div>
            
              <div class="col-12 col-sm-6">
                <img src="/images/tricto-rules-prepare-d-EN.jpg" class="image-responsive mt-n3" />
                <p class="typo-note">
                Hold your 6 cards in your hand
                </p>
              </div>

          

          </div>
          
          `,
        },
      ],
    },

    // Game turn
    {
      title: 'Player turn',
      body: `
      <p>During your turn, you can perform various actions in any order (but you don't have to). After that end your turn by picking up cards.
      </p>
      <p>The game goes clockwise.</p>
      `,
      lastDark: true,
      classes: 'bg-red',
      chapters: [
        {
          title: 'Swap cards',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              You need the right cards in your hand for your actions. You can exchange the cards from your hand with the market and with other players <strong>1:1</strong>.
              </p>
              <p>Yes, 1&nbsp;resource may also be exchanged for 1&nbsp;Samurai or 1&nbsp;Shogun and vice versa.</p>
            </div>

            <div class="col-12 col-sm-6">
            </div>

            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h3>Exchange on the market</h3>
              
              <p>Each turn you are <strong>allowed to</strong> replace the market with 3&nbsp;new cards from the draw pile once. It's optional, you may also just accept it.</p>

              <p><strong>After</strong> that you may exchange cards between your hand and the market 1:1. As long as it's your turn, anytime, and as often as you want.</p>

            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-change-a-EN.jpg" class="image-responsive mt-n3" />
            </div>

            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h3>Exchange with other players</h3>
              
              <p>If you succeed in convincing a fellow player, you can also swap cards 1:1 from hand to hand.</p>

              <div class="rules__hint">
                <p>
                <strong>ADVICE Convincing players</strong><br/>
                Convince with politics. Like, "Exchange cards with me, or I'll attack you!" or "Help me, or this one will win."
                </p>
              </div>
              
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-change-b-EN.jpg" class="image-responsive mt-n3" />
            </div>

          </div>
          `,
        },
        {
          title: 'Training Samurai',
          body: `
          
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              For the defense of your collected materials you need battle-ready Samurai. Of course also to start an attack yourself.
              </p>
              <p>
              Only if you have 1 Samurai and 2 resources of the same color in your hand, you can train the Samurai.
              </p>
              <p>Put the two materials on the discard pile and the Samurai face up in front of you.</p>
              <div class="rules__hint">
                <p> <strong>Colorblind? </strong><br/>
                The 2 icons in white show you the matching resource on each Samurai card:</p>
                <img src="/images/tricto-rules-buy-fighter-d.jpg" class="image-responsive mt-n3" />
              </div>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-buy-fighter-a.jpg" class="image-responsive mt-n3" />
              <img src="/images/tricto-rules-buy-fighter-b.jpg" class="image-responsive mt-n3" />
              <img src="/images/tricto-rules-buy-fighter-c.jpg" class="image-responsive mt-n3" />
            </div>
            
            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h3>3 Samurai Max.</h3>
              <p>
              At the beginning you are allowed to train a maximum of <strong>3 Samurai</strong>.
              </p>
              <p>
              For each appointed Shogun this maximum number increases by 1 Samurai. (See "Appoint Shogun")
              </p>
              <h3>Combination doesn't matter</h3>
              <p>
              The combination of your trained Samurai doesn't matter.
              You may also train several Samurai of the same kind.
              </p>
              
            </div>

            <div class="col-12 col-sm-6">
            <img src="/images/tricto-rules-buy-fighter-e.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              <strong>EXAMPLE:</strong><br/>
              Without Shoguns, you are allowed to train a maximum of 3 Samurai in any combination.
              </p>
              
            </div>

          </div>
          
          `,
        },
        {
          title: 'Appointing a Shogun',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              You can appoint a Shogun, once you have him and the 3 required materials (rice, ore and bamboo) in your hand.
              </p>
              <p>
              Put the 3 materials on the discard pile and the appointed Shogun face up in front of you.
              </p>
              <p>You can appoint as many Shoguns as you like.</p>

              <h3>What purpose does a Shogun have?</h3>
              <p>
                <strong>1.</strong> You draw 1 more card per Shogun at the end of each turn
              </p>
              <p>
                <strong>2.</strong> You can train 1 more Samurai per Shogun
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-buy-booster-a.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
                3 materials on the discard pile,<br/>
                the appointed Shogun face up in front of you.
              </p>
              <img src="/images/tricto-rules-buy-booster-b.jpg" class="image-responsive" />
              <p class="typo-note">
              <strong>EXAMPLE:</strong> If you have 3 Shoguns,
              you are allowed to train a maximum of 6 Samurai.
              </p>
            </div>

          </div>
          
          `,
        },
        {
          title: 'Create Material',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              To build a palace you need these 3 materials: ore, rice and bamboo.
              </p>
              <p>
              Each turn you can place 1 arbitrary material from your hand on your palace building (you don't have to). Collecting 2 or more materials of same kind is allowed.
              </p>

              <p>
              <strong>Watch out!</strong> Once you have collected materials, you are attackable (see "Attack to plunder").
              </p>
              
              <div class="rules__hint">
                <p>
                <strong>ADVICE: </strong>Creating material is only advised if you have trained Samurai for defense.
                </p>
              </div>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-resources-EN.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              <strong>EXAMPLE:</strong><br/>
              1 Rice as material on top of the palace construction
              </p>
            </div>

          </div>
          
          `,
        },
        {
          title: 'Attack to plunder',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
            <p>
            You are allowed to attack once per turn to loot 1 material from an opponent (in addition to creating material).
            </p>
            <h3>When are you allowed to attack?</h3>
            <p>
            Your Samurai will only fight if material lures as loot on your opponent's palace construction. If your opponent has no Samurai for defence, you can loot 1&nbsp;material with your army without fighting (counts as an attack).
            </p>
            </div>
            <div class="col-12 col-sm-6">

            </div>
            
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">1.</span> Combining an Army</h4>
              <p>
              An army consists of <strong>1 to max. 3</strong> Samurai. Only these Samurai fight (no retreat, reinforcements, etc.)!
              </p>
              <p>
               For your attack choose max. 3 of your trained Samurai and show them to the other players. After that the defender chooses the Samurai for his army in the same way.
              </p>

              <div class="rules__hint">
                <p>
                <strong>ADVICE:</strong> Choose strategically the best combination of Samurai, you can also choose several of the same type.
                </p>
              </div>
              <br />

              <p>
              The larger army is positioned first (if both are of the same size the attacker begins). Position the Samurai <strong>face down</strong> in a row so only you know their position.
              </p>
              <p>
              Now the other player places one of his Samurai face down opposite each positioned Samurai for a duel.
              </p>
            </div>

            
            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-a-EN.jpg" class="image-responsive mt-n3" />
              <div class="rules__hint rules__hint--light">
                <p>
                <strong>EXAMPLE:</strong> <br/>
                <strong>A</strong> Larger army gets positioned first<br/>

                <strong>B</strong> Each Samurai is faced with one other Samurai if possible
                </p>
              </div>
            </div>

            <div class="col-12">
              <hr />
            </div>
            
            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">2.</span> Battle</h4>
              <p>Now uncover the Samurai who are facing each other for a duel. The icon with the arrow in the upper right corner of the Samurai card shows which other Samurai is beaten. Defeated Samurai go to the discard pile.</p>

              <p>Two Samurai of same type beat each other.</p>

              <p>When all duels are fought, pick up your remaining Samurai and put them face down for another duel (as described in point 1).</p>

              <p>
              Repeat this until one or both armies are completely destroyed.
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-b.jpg" class="image-responsive mt-n3" />
              <div class="rules__hint rules__hint--light">
                <p>
                <strong>EXAMPLE:</strong> <br/>
                <strong>a</strong> Lance- beats Sword-Samurai<br/>
                <strong>b</strong> Two of the same type beat each other<br/>
                <strong>c</strong> Samurai without opponent remains face down
                </p>
              </div>
            </div>

            <div class="col-12">
              <hr />
            </div>
            
            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-a.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Lance beats Sword
              </p>
            </div>

            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-b.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Sword beats Bow
              </p>
            </div>

            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-c.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Bow beats Lance
              </p>
            </div>

            <div class="col-6 col-sm-3">
              <img src="/images/tricto-rules-battle-vs-d.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
              Equal beat each other
              </p>
            </div>

            <div class="col-12">
              <hr />
            </div>

            <div class="col-12 col-sm-6">
              <h4><span class="typo-highlight">3.</span> Plundering material</h4>
              <p>
              If you as attacker won a battle or both armies were destroyed, take <strong>1</strong>&nbsp;material of your choice from the defender as loot and place it on your palace construction. No, a victorious defender does not get any loot.
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-c.jpg" class="image-responsive mt-n3" />
              <div class="typo-note">
                <p>
                <strong>1</strong> arbitrary material<br/>
                goes to the attackers palace construction
                </p>
              </div>
            </div>

            <div class="col-12 col-sm-6">
            <h4><span class="typo-highlight">4.</span> Protection after getting attacked</h4>
            <p>
            If you have been attacked, you are protected from further attacks for the rest of this round (no matter how the battle ended). As a symbol of this, place your remaining materials under your palace construction. Next time it's your turn, put them back face up on top of your palace construction to show you can be attacked again.
            </p>
          </div>

          <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-battle-d.jpg" class="image-responsive mt-n3" />
              <div class="typo-note">
                <p>
                <strong>Protection mode:</strong><br/> Remaining material protected under the palace construction
                </p>
              </div>
            </div>

          </div>
          
          `,
        },
        {
          title: 'Building a Palace',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>Once you have collected the 3 different materials rice, ore and bamboo on top of your palace construction, your palace is finished and you're one step closer to your victory.
              </p>
              <p>
              Put the 3 materials on the discard pile and uncover 1 palace.</p>

              <div class="rules__hint">
                <p>
                <strong>BE AWARE!</strong> We are talking about material that was produced or plundered. You can't take resources directly from your cards on your hand.
                </p>
              </div>

            </div>

            <div class="col-12 col-sm-6">
              <img src="/images/tricto-rules-build-objective.jpg" class="image-responsive mt-n3" />
              <p class="typo-note">
                Put the 3 materials on the discard pile <br/>
                and uncover 1 palace
                </p>
            </div>

          </div>
          
          `,
        },
        {
          title: 'End of Turn',
          body: `
          <div class="row">
            <div class="col-12 col-sm-6">
              <p>
              End your turn by drawing from the draw pile until you have 6&nbsp;cards in your hand again.
              </p>
              <p>

              For each appointed <strong>Shogun</strong> you recieve 1&nbsp;extra card.
              </p>
              <p>
              That's the end of your turn, the next one is up!
              </p>
            </div>

            <div class="col-12 col-sm-6">
              <p class="typo-note text-left">
              <strong>EXAMPLE:</strong> 
              If you have 1 Shogun,<br/>
              you fill up your hand cards to 7
              </p>
              <p class="typo-note text-left">
              <strong>EXAMPLE:</strong> 
              If you have 3 Shoguns,<br/>
              you fill up your hand cards to 9
              </p>
            </div>

          </div>
          
          `,
        },
      ],
    },

    // Ninja
    {
      title: 'The Ninja',
      classes: 'bg-night',
      body: `
      <p>The Ninja appears unexpectedly from the draw pile and fights for the weakest player.</p>
      <p>You drew the Ninja? Put him face up immediately and draw another card in his place.</p>
      `,
      chapters: [
        {
          title: 'Ninja Attacke',
          body: `<div class="row">
          <div class="col-12 col-sm-6">
            <p>
            The Ninja only fights for the weakest player. You're weakest if one of the following questions applies. If the question applies to more than one player, go to the next one:
            </p>
            <p>
           <strong>1.</strong> Do you have the fewest built palaces?
            </p>
            <p>
            <strong>2.</strong> Do you have the fewest materials?
            </p>
            <p>
            <strong>3.</strong> Do you have the fewest Shoguns?
            </p>
            <p>
            <strong>4.</strong> Do you have the fewest Samurai?
            </p>
            <p>
            <strong>5.</strong> Have you drawn the Ninja?
            </p>

            <hr/>

            <h3>The Ninja attacks in silcence</h3>
            <p>
            As the weakest player, you decide who is the Ninja's victim.
            </p>
            
            <p>
            The Ninja <strong>either</strong> steals 1 material from the victim and brings it to your palace construction (Protection mode has no effect here).
            </p>
            
            <p>
            <strong>Or</strong> he silently assassinates 1 of the victim's Shogun and lets him disappear on the discard pile (victim's additionally trained Samurai remain). The choice is yours.
            </p>

            <hr/>

            <h3>The Ninja disappears</h3>
            <p>
            Take the draw pile and the discard pile together with the Ninja. Shuffle these cards well and place them face down as a new draw pile.
            </p>
            </div>
        
          <div class="col-10 col-sm-6">
            <div class="px-10">
            <img src="/images/tricto-rules-special-card.jpg" class="image-responsive mt-n3"/>
            </div>
          </div>
        
        </div>`,
        },
      ],
    },
  ],
  outro: {
    title: 'End of Game',
    body: `
    <div class="text-center">
    <p>
    As soon as you built your 3rd palace, you are the great emperor and have won the game.
    </p>
    <img class="pl-4" src="/images/tricto-rules-game-end-a.png" class="image-responsive mt-n3"  style="max-width: 320px"/>
    <p>
    <br/>
    With 5 or 6 players, you have won with your second palace.
    </p>
    <img class="pl-4" src="/images/tricto-rules-game-end-b.png" class="image-responsive mt-n3" style="max-width: 320px" />
    <br />
    <br/>
    <p>
    Congratulations Strategist-San!
    <br/>
    Time for the next round. Unless you're afraid of a revenge?!
    </p>
    </div>
    
    `,

    body2: `
      <h2 class="typo-hl-1">Thank you for playing</h2>
      <p><strong>If you have any questions or feedback, please contact us!</strong></p>

      <div class="row">
        <div class="col-12 col-sm-6">
          <a class="btn-icon" href="https://www.instagram.com/play.tricto/" target="_blank" title="Follow @play.tricto on Intagram"><span class="btn-icon__icon btn-icon__icon--insta"></span><span class="btn-icon__text">Follow on Instagram</span></a>
          </div>
          <div class="col-12 col-sm-6">
          <a class="btn-icon" title="Write an email" href="mailto:info@playtricto.com"
          title="Screibe uns eine E-Mail" target="_blank"><span class="btn-icon__icon btn-icon__icon--mail" ></span> <span class="btn-icon__text">Write an email</span></a>
        </div>
      </div>
    `,
  },
};

export default rules;
